export default __webpack_public_path__ + "static/media/commodity.6943772a.svg";